var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 191,
    viewBox: "0 0 191 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 95.4953,
    cy: 95.4992,
    r: 94.7374,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.6786 113.461C76.5932 113.461 60.51 122.193 50.2705 135.744C48.0667 138.661 46.9648 140.119 47.0009 142.09C47.0287 143.613 47.9849 145.534 49.183 146.474C50.7337 147.691 52.8827 147.691 57.1807 147.691H132.177C136.475 147.691 138.624 147.691 140.174 146.474C141.372 145.534 142.329 143.613 142.356 142.09C142.392 140.119 141.291 138.661 139.087 135.744C128.847 122.193 112.764 113.461 94.6786 113.461Z",
    fill: "#CDD8FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6786 96.3454C108.857 96.3454 120.351 84.8514 120.351 70.6727C120.351 56.4941 108.857 45 94.6786 45C80.5 45 69.0059 56.4941 69.0059 70.6727C69.0059 84.8514 80.5 96.3454 94.6786 96.3454Z",
    fill: "#CDD8FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.504052f3dd5ac9a246c78b6330cbeb4c.svg";
export { ForwardRef as ReactComponent };